export default "__VITE_ASSET__dXIx$xIc__"